import { Component, OnInit, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { LayoutService } from './services/layout.service';
import { EmailTemplateService } from './services/email-templates.service';
import { PermissionService } from './services/permission.service';
import { RoleService } from './services/role.service';
import { UserService } from './services/users.service';

@Component({
	selector: 'app-core',
	templateUrl: './core.component.html'
})
export class CoreComponent implements OnInit, OnDestroy, AfterViewInit {
	documentClickListener: Function;

	constructor(
		public renderer: Renderer2,
		public layoutService: LayoutService,
		private emailService: EmailTemplateService,
		private permissionService: PermissionService,
		private roleService: RoleService,
		private userService: UserService
	) {}

	ngOnInit(): void {}

	ngAfterViewInit() {
		// hides the overlay menu and top menu if outside is clicked
		this.documentClickListener = this.renderer.listen('body', 'click', () => {
			if (!this.layoutService.isDesktop()) {
				if (!this.layoutService.menuClick) {
					this.layoutService.menuActiveMobile = false;
				}

				if (!this.layoutService.topMenuButtonClick) {
					this.layoutService.hideTopMenu();
				}
			}

			this.layoutService.menuClick = false;
			this.layoutService.topMenuButtonClick = false;
		});
	}

	ngOnDestroy() {
		if (this.documentClickListener) {
			this.documentClickListener();
		}
	}
}
